import { render, staticRenderFns } from "./MesaPartesVirtual.vue?vue&type=template&id=50b55e35"
import script from "./MesaPartesVirtual.vue?vue&type=script&lang=js"
export * from "./MesaPartesVirtual.vue?vue&type=script&lang=js"
import style0 from "./MesaPartesVirtual.vue?vue&type=style&index=0&id=50b55e35&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports